interface Booking {
  checkin: string;
  checkout: string;
  adult: string;
  child: string;
  
  
  
}
export class ShareService {
   
    API_URL: string;
    BOOKING: Booking;    
    EMAIL:string;
    ADDRESS:string;
    CONTACTNO:string;
    COPYWRITE:string;
    METATITLE:string;
    SITEINFO:Array<any>;
    ROOMINFO:Array<any>;
    BOOKINGDETAIL:Array<any>;
    PAYMENT_INFO:Array<any>;
    DEFAULT_TITLE:string;
    GRAND_TOTAL:string;
   constructor() {
   
    let url = window.location.protocol +'//'+ window.location.hostname; 
      if(url=='http://www.bigtos.com')
      {
	      url='http://www.tradelit.in';
      }
      
      
      this.API_URL = url+'/api';
     
      
      console.log("URL"+url);
      
      
		}
		    

    getSiteurl() {
        let url = window.location.protocol +'//'+ window.location.hostname;
        
        
        return url;
    }
    getToken() {
		let token = document.querySelector('meta[property="csrf-token"]')['content'];
		return token;
	}
	getmainjs(){
	    let token = document.querySelector('meta[property="mainjs"]')['content'];
		return token;

		
	}

    getApiUrl() {
      return this.API_URL;
    }

    setemail(DATA)
    {
      this.EMAIL=DATA;
    }
    getemail(){
      return this.EMAIL;

    }  
    
    setroominfo(room)
    {
	    this.ROOMINFO=room;
    }
    
    getroominfo(){
      return this.ROOMINFO;

    }
    
    setsiteinfo(DATA)
    {
      this.SITEINFO=DATA;
    }
    getsiteinfo(){
      return this.SITEINFO;

    }  
     setbooking(DATA)
    {
      this.BOOKING=DATA;
    }
    getbooking(){
      return this.BOOKING;

    } 
    
    
      
     setetitle(DATA)
    {
      this.DEFAULT_TITLE = DATA;
    }
    getetitlel(){
      return this.DEFAULT_TITLE;

    }
    
    setcopywrite(DATA)
    {
      this.COPYWRITE = DATA;
    }
    getcopywrite(){
      return this.COPYWRITE;

    }
    setbookingdetail(DATA)
    {
      this.BOOKINGDETAIL = DATA;
    }
    getbookingdetail(){
      return this.BOOKINGDETAIL;

    }
    setgrandtotal(DATA)
    {
      this.GRAND_TOTAL = DATA;
    }
    getgrandtotal(){
      return this.GRAND_TOTAL;

    }
    
    
    setPaymentinfo(DATA)
    {
      this.PAYMENT_INFO = DATA;
    }
    getPaymentinfo(){
      return this.PAYMENT_INFO;

    }
    

}



// WEBPACK FOOTER //
// ./resources/assets/typescript/services/services.ts